export default "__VITE_ASSET__ab89b66a__"